import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.72 9.474a.75.75 0 0 0 0 1.061l4.25 4.25a.75.75 0 1 0 1.06-1.06l-3.72-3.72 3.72-3.72a.75.75 0 1 0-1.06-1.06zm9.25-4.25-4.25 4.25a.75.75 0 0 0 0 1.061l4.25 4.25a.75.75 0 1 0 1.06-1.06l-3.72-3.72 3.72-3.72a.75.75 0 0 0-1.06-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }